import { render, staticRenderFns } from "./addFeeConcession.vue?vue&type=template&id=b57bf726"
import script from "./addFeeConcession.vue?vue&type=script&lang=js"
export * from "./addFeeConcession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports